<template>
  <div class="order-product-info">
    <div class="order-product-main">
      <div class="main-label">商品信息</div>
      <div class="modalItemContent">
        <div>
          <!-- 总数量使用未拆单数量，拆单数量不跟主单一起的发货 -->
          <template v-if="isPlatformOrder || isOzon">
            <span>商品总数量：{{ notSpiltTotal }}</span>
          </template>
          <template v-else>
            <span>订单商品数量：{{ goodsTotalQuantity }}</span>
            <span class="ml15">应发商品数量：{{ setProductDetail.dispatchedTotal }}</span>
            <span class="ml15">已发商品数量：{{ setProductDetail.sentTotal }}</span>
            <span class="ml15">未发商品数量：{{ setProductDetail.unsentTotal }}</span>
            <span
              class="ml15 mb5 pointer-font"
              style="display:inline-block;"
              v-if="isShowReissueCommodity"
              @click="openReissueCommodityModal"
            >补发未发商品</span>
          </template>
          <span
            v-if="isOzon && notSpiltTotal > 1 && getOzonCurrent"
            class="pointer-font ml20 mb5"
            @click="openSplitModal"
            style="display:inline-block;"
          >
            拆单
          </span>
          <span
            v-if="isShowPartShipments"
            class="pointer-font ml20 mb5"
            @click="partShipmentsHand"
            style="display:inline-block;"
          >
            部分发货
          </span>
        </div>
        <Row
          v-for="(item, index) in orderTransactionsList"
          class="orderDetailsProductItem"
          :class="{
            'is-check-product': getOrderTransactionId === item.webstoreOrderTransactionId,
            'last-item-box': index == orderTransactionsList.length - 1 || (index == 4 && !isListExtend),
            'is-platform-order': isPlatformOrder
          }"
          v-show="isListExtend || index < 5"
          :key="`order-${index}`"
        >
          <div class="row-info-td orderDetailsProductItemPic">
            <img :src="item.pictureUrl === null ? placeholderSrc : item.pictureUrl">
          </div>
          <div class="row-info-td order-product-middle">
            <div class="odpidProductID">
              <div v-if="item.webstoreItemId">
                <div>
                  <span class="productHaveATitle">itemID：</span>
                  <a
                    class="productID mr10 cursor-und"
                    v-if="isPlatformItem"
                    target="_blank"
                    @click="goItemUrl(item)"
                    style="color:#f20;"
                  >{{ item.webstoreItemId }}</a>
                  <span v-else class="productID mr10" style="color:#f20;">{{ item.webstoreItemId }}</span>
                </div>
                <template v-if="['aliexpress'].includes(activePlatform)">
                  <span v-if="combinedOrder" class="combined_order">合单</span>
                  <span v-if="tenDaysOrder" style="background-color: #ff9b04;" class="combined_order">十日达</span>
                  <span v-if="item.isPlatformShippedTransaction === 1" style="background-color: #04ff75;" class="combined_order">认证仓</span>
                  <template v-if="item.orderTransactionExtend">
                    <span v-if="item.orderTransactionExtend.aliexpressAlreadyTaxed === 'I_TAXED'" style="background-color: #04A7FF;" class="combined_order">
                      跨境已税
                    </span>
                    <span v-if="item.orderTransactionExtend.aliexpressAlreadyTaxed === 'U_TAXED'" style="background-color: #CE7515;" class="combined_order">
                      海外仓已税
                    </span>
                  </template>
                </template>
                <span
                  v-if="['ebay', 'customer'].includes(activeInGroup) && getPermission('orderInfo_ebaySendBuyerMessage')"
                  class="contact-buyers"
                  @click="openContactBuyersModal(item)"
                >
                  <Icon size="16" type="md-text" />联系买家
                </span>
                <span v-if="activePlatform === 'amazon' && item.orderTransactionExtend" class="ml10">
                  asin: <a @click="goListing(item)">{{ item.orderTransactionExtend.amazonAsin }}</a>
                </span>
              </div>
              <span class="productHaveATitle">SKU: <em>{{ item.webstoreSku }}</em></span>
              <span class="productHaveATitle" v-if="activePlatform === 'ebay'">物品所在地: <em>{{ item.location }}</em></span>
              <!--
                匹配添加
                valueCode = orderInfo->webstoreItemSite (如果orderInfo->webstoreItemSite不为空需加这个条件)
                valueCnName = orderInfo->orderTransactioin->buyerShippingMethod
                如果根据这两个条件能从出参里取取到记录，那么显示出参对应的remark字段，否则还是显示原来的buyerShippingMethod
              -->
              <span class="productLogsticService" v-if="!['temux'].includes(activePlatform)">
                物流服务：
                <em v-if="orderParameterJson[item.buyerShippingMethod]">
                  {{ orderParameterJson[item.buyerShippingMethod].remark }}
                </em>
                <em v-else>{{ item.buyerShippingMethod }}</em>
              </span>
              <span class="productLogsticService" v-if="['temux'].includes(activePlatform)">
                平台要求发货仓库：
                <em>{{ item.inventoryDeductionWarehouseName }}</em>
              </span>
            </div>
            <div v-if="!$common.isEmpty(Number(item.productsPrice)) && activePlatform === 'ebay'">
              <!-- <div>销售单价：{{ `${Number(item.productsPrice).toFixed(2)} ${item.productsCurrency || ''}` }}</div> -->
              <div>
                实际付款金额：
                <span style="color:#f20;">{{ `${Number(item.productsPrice).toFixed(2)} ${item.productsCurrency || ''}` }}</span>
              </div>
            </div>
            <div class="odpidProductDetails" :title="`名称：${item.title}`">
              {{ item.title }}
            </div>
            <!-- 标记匹配商品 -->
            <div v-if="!isPlatformOrder">
              <span v-if="(item.matchType === 0)" style="margin-right: 5px;">
                <span class="tips-tag-txt tips-tag-error" title="匹配状态">匹配LAPA商品失败</span>
                <Button
                  type="text"
                  v-if="showMarryGoods"
                  @click="marryGoods({index: index, item: item})"
                  size="small"
                  :disabled="marryStatus"
                  style="color:#0000FF;"
                  title="点击匹配商品"
                >匹配商品</Button>
              </span>
              <template v-if="$common.isEmpty(item.skipMatchingProduct) || item.skipMatchingProduct != 1">
                <span class="tips-tag-txt" v-if="(item.matchType === 1)" title="匹配状态">匹配LAPA商品成功</span>
                <span class="tips-tag-txt " v-if="(item.matchType === 2)" title="匹配状态">匹配LAPA商品成功(人工匹配)</span>
              </template>
              <span v-else class="tips-tag-txt" title="匹配状态">已跳过商品匹配</span>
              <span class="tips-tag-txt tips-tag-brand ml5" v-if="isShowBrandName" title="品牌">
                品牌：{{ item.ottoBrandName || '' }}
              </span>
            </div>
          </div>
          <div class="row-info-td orderDetailsQuantity">
            <span style="white-space: nowrap;">X {{ item.quantity }}</span>
            <div
              class="redColor noInPack ml5"
              style="white-space: nowrap;"
              v-if="packageGoodsQuantity !== null && (item.quantity - packageGoodsQuantity[item.salesRecordNumber]) > 0 &&
                (item.isDeliver === 1 || item.isDeliver === null) && !setNoDelivery"
              >
              <span>{{ item.quantity - packageGoodsQuantity[item.salesRecordNumber] }}</span> 个未包含在包裹中
            </div>
            <div class="ml5" v-if="packageGoodsQuantity !== null" style="white-space: nowrap;">
              <Checkbox
                v-model="setNoDelivery"
                true-value=1
                false-value=0
                v-if="(item.quantity - packageGoodsQuantity[item.salesRecordNumber]) > 0 && (item.isDeliver === 1 || item.isDeliver === null) && !setNoDelivery && hasEdit"
                @on-change="markNoDeliver(item.orderTransactionId)"
              >标记不发货</Checkbox>
            </div>
          </div>
          <div class="row-info-td product-info product-sku-data-box" v-if="!isPlatformOrder">
            <template v-if="productSkuAttrData[`${item.webstoreItemId || ''}${item.webstoreOrderTransactionId || ''}`]">
              <div
                v-for="(webItem, webIndex) in productSkuAttrData[`${item.webstoreItemId || ''}${item.webstoreOrderTransactionId || ''}`]"
                :key="`${item.webstoreSku}-${webItem.sku}-${webIndex}`"
                class="product-sku-attr-data"
                :class="{'product-sku-solid': webIndex != 0}"
              >
                <div class="product-sku-detail">
                  <div v-if="webItem.sku" class="product-info-item">
                    <div class="item-label">sku: </div>
                    <div class="item-content">{{webItem.sku}}</div>
                  </div>
                  <div v-if="webItem.title" class="product-info-item">
                    <div class="item-label">名称: </div>
                    <div class="item-content">{{webItem.title}}</div>
                  </div>
                  <div v-if="!!webItem.variations" class="product-info-item">
                    <div class="item-label">规格: </div>
                    <div class="item-content">
                      <span v-for="(vItem, vIndex) in webItem.variationList" :key="`${vIndex}`" class="product-info-variation">
                        <span>{{vItem.name}}: </span>
                        <span>{{vItem.value}}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="product-sku-number">X {{ webItem.quantity }}</div>
              </div>
            </template>
            <div v-if="isOzon && item.splitQuantity > 0 && !$common.isEmpty(item.ozonSplitOrderRecordList)">
              <div class="product-info-item">
                <div class="item-label">未拆分数量: </div>
                <div class="item-content">{{Number(item.quantity) - Number(item.splitQuantity || '0')}}</div>
              </div>
              <div class="product-info-item">
                <div class="item-label">已拆分数量: </div>
                <div class="item-content">{{item.splitQuantity}}</div>
              </div>
              <div
                class="product-info-item"
                v-if="isOzon && item.splitQuantity > 0 && !$common.isEmpty(item.ozonSplitOrderRecordList)"
              >
                <Poptip trigger="hover" placement="bottom-start">
                  <div class="pointer-font" @click="searchTableData(true, {
                    nowId: `${accountCode || ''}-${orderSalesRecNumber || ''}`,
                    list: item.ozonSplitOrderRecordList
                  })">已拆单</div>
                  <div slot="content">
                    <div>已拆单</div>
                    <div>{{ `主单：${accountCode || ''}-${orderSalesRecNumber || ''}，数量：${notSpiltTotal}` }}</div>
                    <div
                      v-for="(oSp, oIndex) in item.ozonSplitOrderRecordList"
                      :key="`osp-${oIndex}`"
                    >{{ `拆分订单${(oIndex + 1)}：${accountCode || ''}-${oSp.subWebstoreOrderId || ''}，数量：${oSp.quantity}` }}</div>
                    <div>点击图标可查询主单以及拆分订单</div>
                  </div>
                </Poptip>
              </div>
            </div>
            <Spin v-if="!isOzon && productSkuAttrLoading" fix>拼命加载中...</Spin>
          </div>
        </Row>
        <Button
          v-if="orderTransactionsList.length > 5"
          class="product-extend-btn"
          size="small"
          type="primary"
          @click="listExtendHand"
          :title="`${isListExtend ? '收起' : '展开'}商品列表`"
        >
          <Icon v-if="isListExtend" type="ios-arrow-up" />
          <Icon v-else type="ios-arrow-down" />
        </Button>
      </div>
    </div>
    <!-- 人工匹配商品 -->
    <!-- <matchingGoodsModal ref="matchingGoodsModal" :orderInfo="orderInfo" :typeStatus="typeStatus" :inPage="inPage" @updateOrder="marryGoods" /> -->
    <matchingGoodsModal ref="matchingGoodsModal" :orderInfo="orderInfo" :typeStatus="typeStatus" :inPage="inPage" />
    <!-- 联系买家模态框-->
    <buyerMessage ref="buyerMessage" :orderInfo="orderInfo" :platformId="activePlatform" />
    <!-- 拆单弹窗 -->
    <splitOrderModal :modelVisible.sync="spiltModelVisible" :modelData="splitDetailInfo" @updateOrderData="updateOrderData" />
    <!-- 创建补发商品包裹弹窗 -->
    <reissueCommodity :modelVisible.sync="reissueModelVisible" :moduleData="reissueModelData" @updateOrderData="updateOrderData" />
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import matchingGoodsModal from './matchingGoodsModal';
import buyerMessage from '@/views/ebay/components/ebay/buyerMessage';
import splitOrderModal from './splitOrderModal';
import reissueCommodity from '@/components/common/order/reissueCommodity';
import { platformReceptionUrl } from '@/utils/enum';

export default {
  mixins: [Mixin],
  components: {
    matchingGoodsModal,
    buyerMessage,
    splitOrderModal,
    reissueCommodity
  },
  props: {
    platformId: { type: Array, default: () => { return [] } },
    // 是否可以编辑
    hasEdit: { type: Boolean, default: true },
    orderDetailsData: { type: Object, default: () => { return {} } },
    shopDataList: { type: Array, default: () => { return [] } },
    orderInfo: [Object, String],
    packageGoodsQuantity: Object,
    orderRowsDetail: { type: Object, default: () => { return {} } },
    // 来源-从什么地方打开，默认为空
    targetSource: { type: String, default: null },
    inPage: { type: String, default: null },
    // 商品平台sku对应的映射商品详情
    productAttrDetails: {
      type: Object,
      default: () => {
        return {
          loading: true,
          data: {}
        }
      }
    },
  },
  data () {
    // let self = this;
    /**
     * 1.joom
     https://www.joom.com/en/products/{itemID}
     2.速卖通
     https://www.aliexpress.com/item/{itemID}.html
     3.wish
     https://www.wish.com/product/{itemID}
     4.Walmart
     https://www.walmart.com/ip/{itemID}
     5.Amazon(后缀根据店铺所在站点不同)
     https://www.amazon.co.uk/gp/product/{ASIN}
     6.shopee（平台域名和站点相关）
     https://shopee.com.my/product/{shopid}/{itemid}
     * */
    return {
      platformItemUrl: platformReceptionUrl,
      isListExtend: false,
      spiltModelVisible: false,
      splitDetailInfo: {},
      otherLoading: false,
      marryData: {},
      orderParameterJson: {},
      reissueModelVisible: false,
      reissueModelData: {},
      marryStatus: false, // 人工匹配按钮状态控制
      setNoDelivery: false,
      typeStatus: 1, // 表示执行人工匹配功能
      combinedOrder: false, // 合单
      tenDaysOrder: false // 十日达
    };
  },
  watch: {
    inGroup: {
      handler: 'getOrderCommonParameter',
      immediate: true
    },
    orderInfo: {
      handler (data) {
        if (data.orderExtendInfo) {
          let talg = data.orderExtendInfo.aliexpressTagType;
          if (talg !== null) {
            // 合单
            if (talg.indexOf('HBA_UP_EXPRESS') > -1) {
              this.combinedOrder = true;
            } else {
              this.combinedOrder = false;
            }
            // 十日达
            if (talg.indexOf('leadTimeTag#') > -1) {
              this.tenDaysOrder = true;
            } else {
              this.tenDaysOrder = false;
            }
          } else {
            this.combinedOrder = false;
            this.tenDaysOrder = false;
          }
        } else {
          this.combinedOrder = false;
          this.tenDaysOrder = false;
        }
      },
      deep: true,
      immediate: true
    },
    fullInGroup: {
      handler: 'getOrderCommonParameter',
      immediate: true
    }
  },
  computed: {
    // 当前模块
    activeInGroup () {
      if (this.$store.state.fullInGroup) {
        return this.$store.state.fullInGroup || null;
      }
      return this.inGroup || null;
    },
    // 权限
    permission () {
      return {
        // 创建包裹权限
        createPackage: this.getPermission('orderShippingInfo_addOrderShippingInfo')
      }
    },
    // 详情信息
    pageDetail () {
      if (this.$common.isEmpty(this.orderRowsDetail) && this.$common.isEmpty(this.orderDetailsData) && this.$common.isEmpty(this.orderInfo)) return {};
      if (this.$common.isEmpty(this.orderRowsDetail)) {
        if (this.$common.isEmpty(this.orderInfo)) {
          if (this.$common.isEmpty(this.orderRowsDetail) || this.$common.isEmpty(this.orderRowsDetail.orderInfo)) return {};
          return this.orderRowsDetail.orderInfo;
        };
        return this.orderInfo;
      }
      return this.orderRowsDetail;
    },
    // 当前平台
    activePlatform () {
      if (this.$common.isEmpty(this.platformId)) return this.inGroup;
      if (this.$common.isString(this.platformId)) return this.platformId;
      return (this.platformId || []).join(',');
    },
    // 是否平台仓订单   0：不是平台仓订单，1：是平台仓订单
    isPlatformOrder () {
      if (this.$common.isEmpty(this.pageDetail)) return false;
      return [1, '1'].includes(this.pageDetail.isPlatformOrder);
    },
    // 是否为 ozon 平台
    isOzon () {
      return this.activePlatform == 'ozon';
    },
    // 商品平台sku对应的映射商品详情
    productSkuAttrData () {
      if (this.isOzon) return this.originProductAttr;
      if (this.$common.isEmpty(this.productAttrDetails)) return {};
      if (this.$common.isEmpty(this.productAttrDetails.data)) return this.originProductAttr;
      return this.productAttrDetails.data || {};
    },
    // 原来的商品 sku 信息
    originProductAttr () {
      let obj = {};
      let key = '';
      (this.orderTransactionsList || []).forEach(item => {
        // 匹配数据中的 `${row.webstoreItemId || ''}${row.webstoreOrderTransactionId || ''}`;
        key = `${item.webstoreItemId || ''}${item.webstoreOrderTransactionId || ''}`;
        if (!this.$common.isEmpty(key)) {
          if (this.$common.isUndefined(obj[key])) {
            obj[key] = [{
              ...item,
              orderTransactionId: item.orderTransactionId,
              title: item.productName,
            }];
          } else {
            obj[key].push({
              ...item,
              orderTransactionId: item.orderTransactionId,
              title: item.productName,
            });
          }
        }
      });
      return obj;
    },
    // 商品平台sku对应的映射加载中
    productSkuAttrLoading () {
      if (this.$common.isEmpty(this.productAttrDetails)) return true;
      return this.productAttrDetails.loading;
    },
    // 是否在 退货退款页面打开
    isRefundReturn () {
      return ['ebayRefundReturn'].includes(this.targetSource);
    },
    // 是展示匹配名称
    isShowBrandName () {
      // return ['unmatchProduct'].includes(this.targetSource) && ['otto'].includes(this.activePlatform);
      return ['otto'].includes(this.activePlatform);
    },
    // 交易号
    getOrderTransactionId () {
      if (this.$common.isEmpty(this.pageDetail) || !this.isRefundReturn) return '';
      return this.pageDetail.webstoreOrderTransactionId || '';
    },
    // 订单ID
    getOrderId () {
      if (this.$common.isEmpty(this.orderInfo) || this.$common.isEmpty(this.orderInfo.orderId)) return '';
      return this.orderInfo.orderId;
    },
    // 单号
    orderSalesRecNumber () {
      if (this.$common.isEmpty(this.orderInfo)) return '';
      return this.orderInfo.salesRecordNumber || '';
    },
    // 店铺 code
    accountCode () {
      if (this.$common.isEmpty(this.orderInfo) || this.$common.isEmpty(this.orderInfo.saleAccountId)) return '';
      if (this.$common.isEmpty(this.shopDataList)) return '';
      const seekAccount = this.shopDataList.find(seek => {
        return seek.saleAccountId == this.orderInfo.saleAccountId
      })
      if (this.$common.isEmpty(seekAccount)) return;
      return seekAccount.accountCode || '';
    },
    orderTransactionsList () {
      if (this.$common.isEmpty(this.orderInfo) || this.$common.isEmpty(this.orderInfo.orderTransactions)) return [];
      let transactionExtendJson = {};
      const productList = this.orderInfo.orderTransactions.map(item => {
        let variationList = [];
        transactionExtendJson = {};
        if (!this.$common.isEmpty(item.variations)) {
          variationList = item.variations.split(';').map(m => {
            return { name: m.split(':')[0], value: m.split(':')[1] }
          })
        }
        if (!this.$common.isEmpty(item.transactionExtendJson) && this.$common.isString(item.transactionExtendJson)) {
          transactionExtendJson = JSON.parse(item.transactionExtendJson);
          if (!this.$common.isJson(transactionExtendJson)) {
            transactionExtendJson = {};
          }
        }
        return {
          ...item,
          ozonSplitOrderRecordList: this.orderInfo.ozonSplitOrderRecordList || [],
          variationList: variationList,
          transactionExtendJson: transactionExtendJson,
          inventoryDeductionWarehouseName: transactionExtendJson.inventoryDeductionWarehouseName || '',
        }
      });
      return productList;
    },
    // 订单商品总数
    goodsTotalQuantity () {
      let total = 0;
      this.orderTransactionsList.forEach(row => {
        if (!this.$common.isEmpty(Number(row.quantity))) {
          total += Number(row.quantity);
        }
      });
      return total;
    },
    // 未作废且未发送的包裹
    notSentPackage () {
      const canAddPack = this.packageList.filter(item => {
        return this.$common.isEmpty(item.despatchTime) && item.packageStatus != 99;
      });
      return canAddPack;
    },
    // 已发送的包裹
    sentPackage () {
      const canAddPack = this.packageList.filter(item => {
        return !this.$common.isEmpty(item.despatchTime) && item.packageStatus != 99;
      });
      return canAddPack;
    },
    // 商品发货相关的数量
    setProductDetail () {
      if (this.productSkuAttrLoading) {
        return {
          dispatchedTotal: '--',
          sentTotal: '--',
          unsentTotal: '--',
        }
      }
      let obj = {
        dispatchedTotal: 0,
        sentTotal: 0,
        unsentTotal: 0,
      }
      if (this.isOzon) return obj;
      Object.values(this.productSkuAttrData).forEach(arr => {
        (arr || []).forEach(item => {
          if (!this.$common.isEmpty(Number(item.quantity))) {
            obj.dispatchedTotal += Number(item.quantity);
          }
        });
      });
      this.sentPackage.forEach(page => {
        if (!this.$common.isEmpty(page.orderShippingDetailList)) {
          page.orderShippingDetailList.forEach(item => {
            if (!this.$common.isEmpty(Number(item.quantity))) {
              obj.sentTotal += Number(item.quantity);
            }
          })
        }
      });
      obj.unsentTotal = obj.dispatchedTotal - obj.sentTotal;
      if (obj.unsentTotal < 0) {
        obj.unsentTotal = 0;
      }
      return obj;
    },
    // 未拆单的数量
    notSpiltTotal () {
      let spiltTotal = 0;
      (this.orderInfo.ozonSplitOrderRecordList || []).forEach(row => {
        if (!this.$common.isEmpty(Number(row.quantity))) {
          spiltTotal += Number(row.quantity);
        }
      });
      return this.goodsTotalQuantity - spiltTotal;
    },
    // 是否显示匹配商品按钮
    showMarryGoods () {
      if (!this.hasEdit || this.$common.isEmpty(this.orderInfo) || this.$common.isEmpty(this.orderInfo.payTime)) return false;
      if ([1, '1'].includes(this.orderInfo.isInvalid) || ['dispute'].includes(this.inPage)) return false;
      return this.getPermission('orderTransaction_matchProductGoods');
    },
    isPlatformItem () {
      // 需要跳转的平台
      return Object.keys(this.platformItemUrl || {}).includes(this.activeInGroup);
    },
    fullInGroup () {
      return this.$store.state.fullInGroup;
    },
    // 是否 JIT 订单(jit 就表示是全托管(半托管)订单)
    isJIT () {
      if (this.$common.isEmpty(this.pageDetail)) return false;
      return this.pageDetail.orderType === 'JIT';
    },
    // 包裹数据
    packageList() {
      const orderShippingDetails = this.$store.state.orderShippingDetails;
      if (!this.$common.isEmpty(orderShippingDetails)) {
        return orderShippingDetails;
      }
      if (this.$common.isEmpty(this.pageDetail)) return [];
      if (this.$common.isEmpty(this.pageDetail.orderShippingInfos)) {
        if (this.$common.isEmpty(this.pageDetail.orderShippingInfoList)) return [];
        return this.pageDetail.orderShippingInfoList;
      }
      return this.pageDetail.orderShippingInfos || [];
    },
    // 是否显示创建补发商品弹窗
    isShowReissueCommodity () {
      if (this.isJIT || !this.permission.createPackage || this.$common.isEmpty(this.packageList)) return false;
      if (this.productSkuAttrLoading) return false;
      return !this.$common.isEmpty(this.sentPackage) && this.setProductDetail.unsentTotal > 0;
    },
    // 物流信息
    ozonShippingInfoList () {
      if (this.$common.isEmpty(this.packageList)) return {};
      return this.packageList[0];
    },
    // 包裹状态(只对 ozon 处理)
    getOzonCurrent () {
      if (this.$common.isEmpty(this.ozonShippingInfoList)) return false;
      let index = 0;
      let isNull = true;
      const posOzon = [
        this.ozonShippingInfoList.packageCreatedTime, // 创建
        this.ozonShippingInfoList.pickingTime, // 分配
        this.ozonShippingInfoList.getLabelTime, // 下发物流
        this.ozonShippingInfoList.packageGoodsStatus, // 拣货1， 2未拣货
        this.ozonShippingInfoList.printTime, // 打印
        this.ozonShippingInfoList.despatchTime // 结束
      ];
      posOzon.forEach((item, fIndex) => {
        if (isNull && (this.$common.isEmpty(item) || item == 1)) {
          index = fIndex;
          isNull = false;
        }
      });
      // 下发物流后不能拆单
      return isNull ? false : index <= 2;
    },
    // 是否显示部分发货按钮
    isShowPartShipments () {
      if (!['otto'].includes(this.activePlatform)) return false;
      // 是否已跳过发货 1 已跳过商品匹配(证明已部分发货) 0 未处理过
      const skippedInfo = this.orderTransactionsList.find(item => item.skipMatchingProduct == 1);
      if (!this.$common.isEmpty(skippedInfo)) return false;
      const matchFail = this.orderTransactionsList.find(item => item.matchType == 0);
      const matched = this.orderTransactionsList.find(item => [1, 2].includes(Number(item.matchType)));
      if (this.$common.isEmpty(matchFail) || this.$common.isEmpty(matched) || !this.$common.isEmpty(this.packageList)) return false;
      return this.getPermission('orderTransaction_partialDelivery');
    },
  },
  created () {
    this.isListExtend = false;
  },
  methods: {
    goItemUrl (item) {
      /**
       * 跳转到对应平台
       * @params item 当前操作对象
       * customer 是客服系统
       * */
      if (this.$common.isEmpty(this.platformItemUrl[this.activeInGroup])) return;
      const itemId = item.webstoreItemId || '';
      const amazonAsin = item.orderTransactionExtend ? item.orderTransactionExtend.amazonAsin || '' : '';
      let shopeeShopId = '';
      if (this.$store.state.orderDetails && this.$store.state.orderDetails.accountInfo) {
        shopeeShopId = this.$store.state.orderDetails.accountInfo.shopeeShopId || '';
      }
      const openUrl = this.platformItemUrl[this.activeInGroup](itemId, amazonAsin, shopeeShopId);
      window.open(openUrl);
    },
    // 刷新订单数据
    updateOrderData (val) {
      this.$emit('updateOrderData', val);
    },
    getOrderCommonParameter () {
      this.orderParameterJson = {};
      if (this.$store.state.commonParameter.length > 0) {
        (this.$store.state.commonParameter || []).forEach(item => {
          this.$set(this.orderParameterJson, item.valueCnName, item);
        });
        if (this.fullInGroup) {
          if (this.$store.state.commonParameter[0].parameterCode === this.fullInGroup) return;
        } else {
          if (this.$store.state.commonParameter[0].parameterCode === this.activePlatform) return;
        }
      }
      this.axios.post(api.get_orderCommonParameter, {
        parameterName: 'shipmentType',
        parameterCode: this.$store.state.fullInGroup || this.activePlatform
      }).then(res => {
        if (res && res.data && res.data.code === 0) {
          this.$store.commit('commonParameter', res.data.datas);
          (res.data.datas || []).forEach(item => {
            this.$set(this.orderParameterJson, item.valueCnName, item);
          });
        }
      });
    },
    goListing (item) {
      let newTab = window.open('about:blank');
      this.axios.get(`${api.erpServiceCommon}common-service/${api.get_site}?siteIdList=${this.orderInfo.webstoreItemSite}&platformId=amazon`).then(res => {
        if (res.data.code === 0 && item.orderTransactionExtend) {
          if (res.data.datas && res.data.datas.length > 0) {
            newTab.location.href = 'https://www.' + res.data.datas[0].url + '/gp/product/' + item.orderTransactionExtend.amazonAsin;
          } else {
            this.$Message.error('接口数据为空');
          }
        }
      });
    },
    openContactBuyersModal (data) {
      this.$refs.buyerMessage.model1 = true;
      this.$store.commit('contactBuyer', data);
    },
    markNoDeliver (id) {
      this.axios.post(api.set_orderNoDeliver + '?orderTransactionId=' + id);
    },
    marryGoods (config) { // 人工匹配模态框
      let item = config.item;
      const index = config.index;
      if (item == 'again') {
        item = this.marryData;
      } else {
        this.marryData = item;
      }
      let sku = null;
      if (item.sku) {
        sku = item.sku;
      } else {
        sku = item.variations ? item.webstoreItemId + item.variations : item.webstoreItemId;
      }
      this.marryStatus = true;
      let obj = {
        sku: sku
      };
      this.axios.post(api.qury_productSku, obj).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let obj = {
              businessId: data.businessId,
              orderId: item.orderId,
              orderTransactionId: item.orderTransactionId,
              productName: data.productName,
              source: data.source
            };
            this.axios.post(api.match_productGoods, obj).then(response => {
              this.marryStatus = false;
              if (response.data.code === 0) {
                this.$parent.updateStatus = true;
                this.searchTableData(); // 刷新列表
                if (this.inPage === 'combineOrder') {
                  this.$store.commit('combineStatus', true);
                }
              }
            }).catch(() => {
              this.marryStatus = false;
            });
          } else {
            this.marryStatus = false;
            this.$refs.matchingGoodsModal.chioseIndex = index;
            this.$refs.matchingGoodsModal.matchingGoodsStatus = true;
            this.$refs.matchingGoodsModal.matchingGoodsModal = true;
          }
        } else {
          this.marryStatus = false;
        }
      }).catch(() => {
        this.marryStatus = false;
      });
    },
    // 刷新列表
    searchTableData (isClose, obj) {
      this.$nextTick(() => {
        if (isClose) {
          this.$emit('backList');
        }
        let ids = [];
        if (!this.$common.isEmpty(obj)) {
          if (!this.$common.isEmpty(obj.nowId)) {
            ids.push(obj.nowId);
          }
          (obj.list || []).forEach(item => {
            if (!this.$common.isEmpty(item.subWebstoreOrderId)) {
              ids.push(`${this.accountCode}-${item.subWebstoreOrderId}`)
            }
          });
        }
        let backVal = {};
        if (!this.$common.isEmpty(ids)) {
          backVal.orderNo = ids.join(',');
        }
        this.$emit('updateList', backVal);
      })
      // if (!this.$parent || !this.$parent.$parent || !this.$parent.$parent.$parent || !this.$parent.$parent.$parent.getList) return;
      // this.$parent.$parent.$parent.getList();
    },
    // 部分发货
    partShipmentsHand () {
      if (this.otherLoading) return;
      this.otherLoading = true;
      this.axios.post(`${api.partialDelivery}/${this.getOrderId}`).then(response => {
        if (response.data.code === 0) {
          this.$parent.updateStatus = true;
          this.searchTableData(); // 刷新列表
          if (this.inPage === 'combineOrder') {
            this.$store.commit('combineStatus', true);
          }
        }
        this.otherLoading = false;
      }).catch(() => {
        this.otherLoading = false;
      });
    },
    // 打开拆单弹窗
    openSplitModal () {
      this.splitDetailInfo = {
        orderDetails: this.orderDetailsData,
        orderInfo: this.orderInfo
      };
      this.$nextTick(() => {
        this.spiltModelVisible = true;
      })
    },
    // 商品列表展开收起
    listExtendHand () {
      this.isListExtend = !this.isListExtend;
    },
    // 打开补发商品弹窗
    openReissueCommodityModal () {
      let sentObj = {};
      let pKey = '';
      let skuSentObj = {};
      this.sentPackage.forEach(page => {
        if (!this.$common.isEmpty(page.orderShippingDetailList)) {
          page.orderShippingDetailList.forEach(item => {
            //  匹配数据中的 `${item.sku}${item.webstoreItemId || ''}${item.webstoreOrderTransactionId || ''}`;
            pKey = `${item.sku}${item.webstoreItemId || ''}${item.webstoreOrderTransactionId || ''}`;
            if (this.$common.isUndefined(sentObj[pKey])) {
              sentObj[pKey] = 0;
            }
            if (this.$common.isUndefined(skuSentObj[item.sku])) {
              skuSentObj[item.sku] = 0;
            }
            if (!this.$common.isEmpty(Number(item.quantity))) {
              sentObj[pKey] += Number(item.quantity);
              skuSentObj[item.sku] += Number(item.quantity);
            }
          });
        }
      });
      let dispatchedObj = {};
      let skeDispatchedObj = {};
      Object.keys(this.productSkuAttrData).forEach(key => {
        // 匹配数据中的 是 `${item.sku}${item.webstoreItemId || ''}${item.webstoreOrderTransactionId || ''}`;
        (this.productSkuAttrData[key] || []).forEach(item => {
          if (this.$common.isUndefined(dispatchedObj[`${item.sku}${key}`])) {
            dispatchedObj[`${item.sku}${key}`] = 0;
          }
          if (this.$common.isUndefined(skeDispatchedObj[`${item.sku}`])) {
            skeDispatchedObj[`${item.sku}`] = 0;
          }
          if (!this.$common.isEmpty(Number(item.quantity))) {
            dispatchedObj[`${item.sku}${key}`] += Number(item.quantity);
            skeDispatchedObj[`${item.sku}`] += Number(item.quantity);
          }
        })
      });
      // 查找是已发包裹的商品数量否存在异常
      // const isAbnormal = Object.keys(sentObj).find(key => {
      //   if (this.$common.isEmpty(dispatchedObj[key]) || dispatchedObj[key] == 0) return true;
      //   return sentObj[key] > dispatchedObj[key];
      // });
      // 查找已发包裹的商品数量SKU是否存在异常
      const isAbnormal = Object.keys(skuSentObj).find(key => {
        if (this.$common.isEmpty(skeDispatchedObj[key]) || skeDispatchedObj[key] == 0) return true;
        return skuSentObj[key] > skeDispatchedObj[key];
      });
      if (!this.$common.isEmpty(isAbnormal) || this.setProductDetail.sentTotal > this.setProductDetail.dispatchedTotal) {
        // this.$Message.error('存在应发商品/数量与已发商品/数量不匹配，请人工核对创建包裹');
        this.$Modal.warning({
          title: '操作提示',
          width: 600,
          content: '存在应发商品/数量与已发商品/数量不匹配，请人工核对创建包裹',
          onOk: () => {},
          onCancel: () => { }
        });
        return;
      }
      this.reissueModelData = {
        skuData: this.productSkuAttrData,
        sentPackage: this.sentPackage,
        orderDetails: this.orderDetailsData,
        orderInfo: this.orderInfo,
      };
      this.$nextTick(() => {
        this.reissueModelVisible = true;
      })
    },
  }
};
</script>
<style lang="less" scoped>
@orderLeftWidth: 95px; // 订单详情左侧宽度
.order-product-info{
  margin: 10px 0;
  .main-label{
    width: @orderLeftWidth;
    padding: 0 5px;
    font-size: 14px;
    font-weight: bold;
  }
  .orderDetailsProductItem{
    // minmax(auto, 600px)
    margin-top: 0px;
    padding: 0;
    display: grid;
    align-items: center;
    grid-template-columns: 90px minmax(calc(50% - 300px), calc(50% - 80px)) auto minmax(calc(50% - 300px), calc(50% - 80px));
    border: 1px solid #E8EAEC;
    border-bottom: none;
    &.is-platform-order{
      grid-template-columns: 90px auto 90px;
    }
    &.last-item-box{
      border-bottom: 1px solid #E8EAEC;
    }
    &.is-check-product{
      border: 3px solid #cf1c00;
      // box-shadow: 0 0 5px #cf1c00 inset;
    }
  }
  .order-product-main{
    display: flex;
    .modalItemContent{
      width: calc(100% - @orderLeftWidth);
    }
  }
  .order-product-middle{
    flex: 100;
  }
  .row-info-td{
    padding: 8px 12px;
    border-right: 1px solid #E8EAEC;
    &.order-product-middle{
      padding: 8px 12px 8px 0;
    }
    &:first-child{
      border-right: none;
    }
    &:last-child{
      border-right: none;
    }
    &.order-product-middle{
      border-right: none;
    }
    &.product-sku-data-box{
      padding: 0;
    }
  }
  .product-sku-attr-data{
    padding: 8px 12px;
    display: flex;
    align-items: center;
    .product-sku-detail {
      flex: 100;
    }
    .product-sku-number {
      padding-left: 10px;
      max-width: 120px;
    }
    &.product-sku-solid{
      border-top: 1px solid #E8EAEC;
    }
  }
  .orderDetailsQuantity{
    display: flex;
    align-items: center;
    margin-top: 0;
    height: 100%;
    // padding-right: 12px;
  }
  .orderDetailsProductItemPic{
    height: 84px;
    width: 84px;
  }
  .product-info {
    position: relative;
    .product-info-item{
      display: flex;
      .item-content{
        flex: 100;
      }
      .product-info-variation{
        margin-right: 15px;
        // span:nth-child(2){
        //   color: #19BE6B;
        // }
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .tips-tag-txt{
    display: inline-block;
    color: #19BE6B;
    background: rgba(#19BE6B, 0.1);
    font-size: 12px;
    padding: 2px 5px;
    border-radius: 5px;
    &.tips-tag-brand{
      color: #199ebe;
      background: rgba(#199ebe, 0.1);
    }
    &.tips-tag-error{
      color: #f20;
      background: rgba(#f20, 0.1);
    }
  }
}
.combined_order {
  padding: 1px 7px;
  border-radius: 5px;
  display: inline-block;
  background-color: #07c20b;
  color: #fff;
  margin: 0 6px;
  font-size: 12px;
  position: relative;
  top: -3px;
}
.cursor-und:hover {
  text-decoration: underline;
}
.pointer-font{
  cursor: pointer;
  color: #2828ff;
  text-decoration: underline;
  text-underline-position: under;
}
.product-extend-btn{
  display: inline-block;
  margin: 5px auto 0 50%;
  .ivu-icon{
    font-size: 18px;
    font-weight: bold;
  }
}
</style>
